import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { Circle } from "lucide-react"

import { cn } from "@/lib/utils"

const RadioGroupBase = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("grid gap-2", className)}
      {...props}
      ref={ref}
    />
  )
})
RadioGroupBase.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItemBase = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <Circle className="h-2.5 w-2.5 fill-current text-current" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
})
RadioGroupItemBase.displayName = RadioGroupPrimitive.Item.displayName

// --- uiv2: conditional Intui swap (build-time resolved by Vite) ---
import { IntuiRadioGroup, IntuiRadioGroupItem } from '@/components/intueri/IntuiRadioGroup'

const _uiv2 = import.meta.env.VITE_UIV2 === 'true'
const RadioGroup = _uiv2 ? (IntuiRadioGroup as typeof RadioGroupBase) : RadioGroupBase
const RadioGroupItem = _uiv2 ? (IntuiRadioGroupItem as typeof RadioGroupItemBase) : RadioGroupItemBase

export { RadioGroup, RadioGroupItem }
